import React from 'react';

import { useLanguage } from '@hooks/shared/useLanguage';
import { Radio, Space } from 'antd';
import styled from 'styled-components';

const Wrap = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 40px;
`;

const ChangeLanguage: React.FC = () => {
	const { language, setLanguage } = useLanguage();
	return (
		<Wrap>
			<Space wrap>
				<Radio.Group
					defaultValue={language}
					buttonStyle='solid'
					onChange={(e) => setLanguage(e.target.value)}>
					<Radio.Button value='ua'>UKR</Radio.Button>
					<Radio.Button value='en'>ENG</Radio.Button>
					<Radio.Button value='pl'>PL</Radio.Button>
				</Radio.Group>
			</Space>
		</Wrap>
	);
};

export default ChangeLanguage;
